import React from "react";
import PropTypes from "prop-types";

export const ShiftLogPhotosDisplay = ({ photos }) => {
  if (!photos || photos.length === 0) return null;

  return (
    <div className="shift-log-photos-display">
      <b>Photos</b>
      <div className="shift-log-photo-grid">
        {photos.map((photo) => (
          <a
            className="shift-log-photo"
            href={photo.url}
            key={photo.id}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={photo.url} alt={photo.filename} className="shift-log-photo__image" />
          </a>
        ))}
      </div>
    </div>
  );
};

ShiftLogPhotosDisplay.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      filename: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  )
};
